module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFkAAABABAMAAACD/MbPAAAAJ1BMVEUAAAA5w1A5w1A5w1A5w1A5w1A5w1A5w1A5w1A5w1A5w1A5w1A5w1AH2C9LAAAADHRSTlMA6nfejnIMpH710IBpF2ijAAAAr0lEQVRIx2MYPIDJ5gyxwJSBoecM8SCAQYYE1QIMZ0gAB2itmrjA4xlVPQRUD55UNVJSLCtqzjfFr1oHzTsKSKrYja0cUFXLoBccaGaiqsYIKgKqQdwDUIJnAFUjXMuD6m62BIiqNKJU18D8PQXTJZiqEcGE292DUbUjTLEI4TAhHN5DLJ3gVs0uKEwo75CdLzFVM6EaLjQ06oYRUO+Q1grbQ4LqBkSkEwZCDIMHAABaUR5u+aiqJAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/icon-bind-card.png
// module id = 565
// module chunks = 0